import * as React from "react";
import { Button, CircularProgress } from "@mui/material";

interface LoginFormActionsProps {
    primaryLabel: string;
    isPrimarySubmitting: boolean;
    isResendingOtp: boolean;
    isPrimaryDisabled: boolean;
    onPrimaryAction: () => void;
    emailSignInBtnClass: string;
    spinnerClass: string;
    resendSpinnerClass: string;
    showOtpActions: boolean;
    resendCooldownSec: number;
    resendCooldownLabel: string;
    onResendOtp: () => void;
    onBackToEmail: () => void;
    resendOtpButtonClass: string;
    textActionButtonClass: string;
}

export const LoginFormActions: React.FC<LoginFormActionsProps> = ({
    primaryLabel,
    isPrimarySubmitting,
    isResendingOtp,
    isPrimaryDisabled,
    onPrimaryAction,
    emailSignInBtnClass,
    spinnerClass,
    resendSpinnerClass,
    showOtpActions,
    resendCooldownSec,
    resendCooldownLabel,
    onResendOtp,
    onBackToEmail,
    resendOtpButtonClass,
    textActionButtonClass,
}) => (
    <>
        <Button
            variant="contained"
            fullWidth
            className={emailSignInBtnClass}
            onClick={onPrimaryAction}
            disabled={isPrimaryDisabled}
            disableElevation
        >
            {isPrimarySubmitting ? (
                <CircularProgress size={18} className={spinnerClass} />
            ) : (
                primaryLabel
            )}
        </Button>

        {showOtpActions && (
            <>
                <Button
                    fullWidth
                    variant="outlined"
                    className={resendOtpButtonClass}
                    onClick={onResendOtp}
                    disabled={isPrimarySubmitting || isResendingOtp || resendCooldownSec > 0}
                >
                    {isResendingOtp ? (
                        <CircularProgress size={18} className={resendSpinnerClass} />
                    ) : (
                        resendCooldownLabel
                    )}
                </Button>
                <Button
                    fullWidth
                    className={textActionButtonClass}
                    onClick={onBackToEmail}
                    disabled={isPrimarySubmitting || isResendingOtp}
                >
                    Use a different email
                </Button>
            </>
        )}
    </>
);
